export default {
    badge: "Badge",
    close: "Close",
    dataIterator: {
        noResultsText: "No matching records found",
        loadingText: "Loading items..."
    },
    dataTable: {
        itemsPerPageText: "Rows per page:",
        ariaLabel: {
            sortDescending: "Sorted descending.",
            sortAscending: "Sorted ascending.",
            sortNone: "Not sorted.",
            activateNone: "Activate to remove sorting.",
            activateDescending: "Activate to sort descending.",
            activateAscending: "Activate to sort ascending."
        },
        sortBy: "Sort by"
    },
    dataFooter: {
        itemsPerPageText: "Items per page:",
        itemsPerPageAll: "All",
        nextPage: "Next page",
        prevPage: "Previous page",
        firstPage: "First page",
        lastPage: "Last page",
        pageText: "{0}-{1} of {2}"
    },
    datePicker: {
        itemsSelected: "{0} selected",
        nextMonthAriaLabel: "Next month",
        nextYearAriaLabel: "Next year",
        prevMonthAriaLabel: "Previous month",
        prevYearAriaLabel: "Previous year"
    },
    noDataText: "No data available",
    carousel: {
        prev: "Previous visual",
        next: "Next visual",
        ariaLabel: {
            delimiter: "Carousel slide {0} of {1}"
        }
    },
    calendar: {
        moreEvents: "{0} more"
    },
    fileInput: {
        counter: "{0} files",
        counterSize: "{0} files ({1} in total)"
    },
    timePicker: {
        am: "AM",
        pm: "PM"
    },
    pagination: {
        ariaLabel: {
            wrapper: "Pagination Navigation",
            next: "Next page",
            previous: "Previous page",
            page: "Goto Page {0}",
            currentPage: "Current Page, Page {0}"
        }
    },
    rating: {
        ariaLabel: {
            icon: "Rating {0} of {1}"
        }
    },

    start: "Start",
    deadline: "Deadline",
    sure: "Are you sure",
    sureArchive: "Confirm archiving",
    sureOutArchive: "Confirm unarchiving",
    yes: "yes",
    value: "Value",
    addNew: "Add news",
    uploadNewsImage: "Upload cover (jpg, png)",
    publish: "Publish",
    title: "Title",
    addEvent: "Add Event",
    today: "Today",
    month: "Month",
    day: "Day",
    addingEvent: "Adding an event",
    editingEvent: "Editing an event",
    deletingEvent: "Deleting an event",
    time: "Time",
    endDate: "End date",
    allDay: "All day",
    period: "Period",
    confirmDeleteEvent: "Do you really want to delete the selected event? It will be impossible to cancel this action",
    forWhomRule: "Select the event for whom",
    forWhom: "For whom",
    forSelf: "For myself",
    forGroup: "For a group",
    forAll: "For everyone",
    forUser: "For the user",
    description: "Description",
    confirm: "Confirm",
    aboutObject: "About the object",
    worksEnd: "End date of work",
    worksEndLate: "End date with delay",
    worksStart: "Start date of work",
    objectName: "Object name",
    square: "Square",
    accidentInsurance: "Accident insurance",
    healthInsurance: "Health insurance",
    habitation: "habitation",
    number: "Number",
    name2: "Name",
    shortName: "Short name",
    position: "Position",
    name: "Name",
    surname: "Last name",
    no: "no",
    have: "yes",
    phone: "Phone",
    email: "E-mail",
    ogrn: "Registration number",
    address: "Address",
    staff: "Staff of employees",
    documents: "Documents",
    planning: "Planned",
    inProgress: "In progress",
    finished: "Completed",
    back: "Back",
    cancel: "Cancel",
    forward: "Next",
    documentName: "Document name",
    documentType: "Document type",
    dateDownload: "Upload date",
    objectNumber: "Object number",
    objectAddress: "Address of the object",
    client: "Client",
    clientPhone: "Client's phone",
    clientEmail: "Client's email",
    employesOnObject: "Workers on the object",
    workList: "List of jobs",
    comments: "Comments",
    comment: "Comment",
    news: "News",
    readAlso: "Read also",
    save: "Save",
    addCard: "Add a card",
    addWork: "Add a job",
    addEmployee: "Add an employee",
    addObject: "Add an object",
    editObject: "Edit object",
    addContact: "Add contact",
    editContact: "Edit contact",
    addGroup: "Add a group",
    editGroup: "Edit group",
    addTimeReport: "New report",
    editTimeReport: "Edit report",
    addClient: "Add client",
    addDocument: "Add a document",
    add: "Add",
    changePhoto: "Change photo",
    changeSignature: "Change signature",
    changeDocument: "Change document",
    bankAccount: "Bank account",
    systemRole: "Role in the system",
    aboutEmployee: "About the employee",
    cards: "Cards and passes",
    skills: "Skills",
    roof: "Roof installation",
    floor: "Laying the floor",
    personalInfo: "Personal information",
    citizenship: "Citizenship",
    birthday: "Birthday",
    addressOwn: "Address of residence in the native country",
    addressFin: "Address of residence in Finland",
    otherPhone: "Additional phone",
    additional: "Additional",
    driverLicense: "Driver's license",
    driverLicenseCat: "Driver's license category",
    ownCar: "Personal car",
    ownTools: "Own tool",
    haveOwnCar: "Have your own car",
    haveOwnTools: "Have your own tool",
    languages: "Language proficiency",
    uniform: "Working form",
    editPersonal: "Editing personal information",
    editAdditional: "Editing additional information",
    fromFinland: "I'm from Finland",
    fromAnotherCountry: "I'm from another country",
    socialCodeFin: "Finnish henkilotunnus",
    taxNumber: "Veronumero",
    street: "Street",
    house: "House",
    flat: "Apartment",
    entrance: "Entrance",
    index: "Index",
    city: "City",
    country: "Country",
    sizeUniform: "Working form size",
    size: "Size",
    shirt: "T-shirt",
    pants: "Trousers",
    jacket: "Jacket",
    boots: "Boots",
    gloves: "Gloves",
    cardNumber: "Document number",
    dueDate: "Expiration date",
    uploadImg: "Upload image (jpg, png)",
    changeImg: "Change photo (jpg, png)",
    deleteCard: "Delete Card",
    paintingWorks: "Painting works",
    outdoor: "Outdoor",
    indoor: "Indoor",
    plastering: "Plastering works",
    manual: "Manual",
    hardware: "Hardware",
    facade_plasteir: "Facade plaster",
    chain: "With a chain link",
    plasterboard: "With plasterboard",
    alignment: "Alignment",
    carpentry: "Carpentry",
    simple: "Ordinary",
    formwork: "With formwork",
    suspendedCeilings: "Suspended ceilings",
    giprok: "Giprok",
    panels: "Panels",
    partitionWalls: "Partition walls",
    tileWaterproofing: "Tile + waterproofing",
    Floor: "Laying the floor",
    parquet: "Parquet",
    laminate: "Laminate",
    masonry: "Masonry of stone and brick",
    concrete_works: "Concrete works",
    reinforcement: "Reinforcement",
    tiles: "Tile",
    metal: "Metal",
    bitumen: "Bitumen works",
    bitumen_roof: "Roof",
    bitumen_plinth: "Base",
    welding: "Welding",
    diamondCuttingDrilling: "Diamond cutting and Drilling",
    fillForm: "Fill in all required fields",
    addDocumentRule: "Add document to form",
    required: "Required field",
    enterText: "Enter your message",
    enterWorkText: "Enter job title",
    lettersOnly: "Enter alphabetic characters only",
    incorrectEmail: "Incorrect E-mail",
    companyName: "Company name",
    activityType: "Type of activity",
    regNumber: "Reg. number",
    website: "Website",
    logo: "Logo",
    editClient: "Edit Client",
    edit: "Edit",
    delete: "Delete",
    surnameName: "Last name, first name",
    speciality: "Specialty",
    company: "Company",
    mainInfo: "Basic Information",
    downloadDocument: "Download a document (pdf, doc, docx, jpg)",
    downloadPhoto: "Upload photo (jpg, png)",
    date: "Date",
    workType: "Works done",
    selectObjectLabel: "Object",
    selectWorker: "Select an employee",
    selectClient: "Select a client",
    selectContact: "Select a contact",
    wages: {
        label: "Payment type",
        piecework: "Piecework",
        hourly: "Hourly",
        fixed: "Fixed rate",
        sum: "Payment",
        rate: "Rate",
        quantity: "Quantity",
        measurement: "Unit",
        hours: "Hours",
        time: "Time (h)"
    },
    measurements: {
        kg: "kg",
        g: "g",
        m: "m",
        m2: "m2",
        m3: "m3",
        pc: "pcs",
        rll: "rll"
    },
    typeBody: "Body type",
    vin: "VIN number",
    regData: "Registration data",
    carView: "Appearance",
    carTechnic: "Technical specifications",
    carDocuments: "Car documents",
    regDate: "Registration date",
    odometer: "Odometer (km)",
    engine: "Engine",
    fuel: "Fuel",
    typeDrive: "Drive",
    transmission: "Transmission",
    color: "Color",
    characteristics: "Characteristics",
    sorts: {
        sortBy: "Sort by",
        search: "Search",
        searchMan: "Search by name, phone or e-mail",
        searchWorker: "Search by worker's name",
        searchObject: "Search by name, number or address",
        searchCar: "Search by name, number or vin",
        searchName: "Search by name, number",
        searchWaybills: "Search by addresses",
        searchContracts: "Search by document name",
        searchDocuments: "Search by document name",
        byObjects: "object",
        byWorkType: "type of work",
        bySum: "payment",
        byTotalSum: "amount",
        byDate: "date",
        byCreateDate: "date of addition",
        byStartDate: "date of beginning",
        byRegDate: "registration date",
        byCategory: "categories",
        byAccountant: "accountant's name",
        byBank: "bank",
        byName: "name",
        bySubject: "subject",
        byClient: "client",
        byStatus: "status",
        byAddress: "address",
        byCost: "cost",
        byCar: "car",
        byFullName: "name",
        byWorkerPosition: "specialty",
        byContactPosition: "position",
        byMileage: "mileage",
        byNumber: "number",
        byBranch: "type of activity",
        byCompany: "company",
        byType: "document type",

        byPhone: "phone",
        byEmail: "email",
        byRegNumber: "reg. number",
    },
    menu: {
        'holidays': 'Holidays',

        charts: 'charts',

        main: "Home",
        news: "News",
        "news-item": "News",
        "news-add": "Add News",
        "news-edit": "Edit News",
        workers: "Workers",
        "workers-item": "Employee",
        "workers-timings": "Hourly employee reports",
        clients: "Notebook",
        "clients-item": "Client",
        partners: "Partners",
        contacts: "Contacts",
        objects: "Objects",
        "objects-item": "Object",
        "object-timings": "Hourly object reports",
        calendar: "Calendar",
        faq: "Support",
        timings: "Reporting",
        accounting: "Accounting",
        settings: "Settings",
        "settings-item": "Settings",
        waybills: "Waybills",
        addWaybill: "Add waybill",
        BookkeepingView: "Accounting",
        documents: "Documents",
        'documents-absence': "Documents",
        'documents-timings': "Reporting",
        addBookkeeping: "Add document",
        garage: "Garage",
        "garage-item": "Garage",
        profile: "Profile",
        "companyProfile": "Company profile",
        'clients-profile': "Profile",
        groups: "Groups",
        AuthLayout: "Authorization",
        ResetPassword: "Password Reset",
        SignUpLayout: "Registration",
        SignUpTenantLayout: "Registration",
        404: "Not found",
        useful: "Useful links",
        absence: "Absence",
        TechnicalWorks: "Technical works",
        todo: "ToDo List",
        "todo-object": "ToDo List",
        catalog: "Catalog",
        addOrder: "Add order",
        editOrder: "Edit order",
        businessCards: "Business cards",
        tenants: "Tenants",
        tariffPlans: "Tariff plans",
        organizations: "Organizations",
        company: "Company data",
        SuccessLayout: "Payment was successful",
        ErrorLayout: "Payment error",
        safe: "Safe",
        notifications: "Notifications",
        SelectCompany: "Select company",
        timingChangesList: "Changes to hourly reports",
        'reports': "Accounting reports",
        'extracts': 'Bank statements',
        'contracts': 'Contracts',
        'property': 'Real estate',
        'purchases': 'Expenses',
        'sales': 'Revenue',
        'offers': 'Price offers',
        "languages": "Languages",
        PrivacyPolicy: "Privacy policy",
        DeleteAccount: "Delete account",
        "personal": "Personal",
        "work": "Work",
        "resources": "Resources",
        "another": "Another",
        "system": "System",
        "about": "About the company",
        "invitePartner": "Invite partner",
        "hh": "Job Search",
        "CVs": "Worker Search",
        "CV": "CV",
        "MyVacancies": "My Vacancies",
        "OrganizationResponds": "Organization Responses",
        "Vacancies": "Vacancies",
        "Vacancy": "Vacancy",
        "MyResponds": "My Responses",
        "MyRespond": "My Response",
        "Responds": "Responses",
        "Respond": "Response",
        "FindOrganizations": "Search for companies",
        "hr": "Hiring",
        "PersonalTasks": "Personal tasks",
        "lists": "Lists",
    },
    goto: "Go to section",
    gotoProfile: "Go to profile",
    archive: "Archive",
    outArchive: "Exit Archive",
    toArchive: "Archive",
    deleteArchive: "Delete from archive",
    printDoc: "Print the questionnaire",
    loadDoc: "Download document",
    main: {
        see_all: "View all",
        profile: {
            label: "Profile"
        },
        news: {
            label: "News"
        },
        calendar: {
            label: "Upcoming events"
        }
    },
    widgets: {
        h1Label: "Widgets",
        new: "New widget",
        selectWidget: "Select widget",
        note: {
            label: "Note",
            lastSave: "Last save",
        },
    },
    workers: {
        skills: {
            outdoor_painting: "Outdoor painting work",
            indoor_painting: "Indoor painting work",
            manual_plastering: "Manual plastering work",
            hardware_plastering: "Hardware plastering work",
            facade_plasteir_chain: "Facade plaster with chain link",
            facade_plasteir_plasterboard: "Facade plaster with plasterboard",
            alignment: "Alignment",
            carpentry_simple: "Carpentry",
            carpentry_formwork: "Carpentry with formwork",
            suspended_ceilings_giprok: "Suspended ceilings (giprok)",
            suspended_ceilings_panels: "Suspended ceilings (panels)",
            partition_walls: "Partition walls",
            tile_waterproofing: "Tile + waterproofing",
            floor_parquet: "Parquet laying",
            floor_laminate: "Laminate laying",
            masonry: "Masonry of stone and brick",
            concrete_works: "Concrete works",
            concrete_installation: "Installation of concrete elements",
            reinforcement: "Reinforcement",
            roof_tiles: "Roof installation (tile)",
            roof_metal: "Roof installation (metal)",
            bitumen_roof: "Bitumen works (roof)",
            bitumen_plinth: "Bitumen works (plinth)",
            welding: "Welding",
            diamond_cutting_drilling: "Diamond cutting and drilling",
            control_loader: "Loader control",
            control_lift: "Lift control",
            control_tractor: "Tractor control",
            control_transport: "Special transport control",
            loader: "Loader",
            lift: "Lift",
            linoleum: "Linoleum",
            epoxy_coating: "Epoxy coating",
            electrics: "Electrics",
            plumbing: "Plumbing work",
            sandblasting: "Sandblasting",
            dismantling: "Dismantling/breaking",
            asbestos: "Asbestos work",
            cleaning: "Cleaning",
        }
    },
    timings: {
        add: "Add report",
        tabs: {
            piecework: "Piecework payment",
            hourly: "Hourly payment",
            fixed: "Fixed rate",
        }
    },
    statistic: "Statistics",
    accounting: {
        card: {
            scan: "Scan",
            worker: "Employee",
            category: "Category",
            period: "Period",
            bank: "Bank",
            date: "Date",
            datecontracts: "Date of conclusion",
            datedocuments: "Signing date",
            dateproperty: "Signing date",
            datepurchases: "Payment date",
            dategarage: "Repair date",
            dateCreate: "Issue date",
            dateReceipt: "Receipt date",
            dateRemind: "Reminder date",
            dateDelivery: "Delivery date",
            dueDate: "Valid until",
            subject: "Subject",
            concluded: "Concluded with",
            name: "Name",
            ContractName: "Contract name",
            DocumentName: "Document name",
            author: "Accountant",
            status: "Status",
            percentDelay: "Overdue interest",
            statusPayed: "Paid",
            statusCreated: "Exposed",
            statusExpired: "Expired",
            cost: "Cost",
            address: "Address",
            sum: "Amount",
            place: "Place",
            tax: "VAT",
            paymentMethod: "Payment method",
            bankCard: "Bank card",
            bankTransfer: "Bank transfer",
            cash: "Cash",
            client: "Customer",
            object: "Object",
            numberLink: "Link number",
            id: "Number",
            number: "Order number",
            description: "Explanation of the invoice",
            comment: "Notes",
            term: "Term",
            addService: "Add service",
            price: "Price",
            discount: "Discount(%)",
            type: "Product/service",
            typeMaterial: "Product",
            typeService: "Service",
            date_start: "Trip Start date",
            date_end: "Trip End date",
            time_start: "Start work",
            time_end: "End work",
            way_time: "Journey time",
            mileage: "Mileage",
            mileageStart: "Km at the beginning",
            mileageEnd: "Km at the end",
            mileageTotal: "Length in km",
            departure: "Departure point",
            destination: "Destination",
            auto: "Car registration number",
            goal: "Purpose of the trip",
            material: "materials, all fasteners and consumables",
            delivery: "delivery of material from a warehouse or store to the object",
            tool: "tool",
            lifts: "lifts",
            scaffolding: "forests",
            montage_scaffolding: "scaffolding installation and dismantling",
            garbage: "garbage removal and disposal",
            garbage_containers: "dumpsters",
            security: "object security",
            social_room: "social rooms with water, the ability to change clothes and eat, toilet",
            unloading: "unloading of material",
            spreading: "distribution of material on the object",
            cleaning: "cleaning on the object",
            numberBill: "Account number",
            bundle: "Set of checks",
            bundleSingle: "One check",
            bundleMultiple: "2 and more",
            car: "Auto"
        },
        statistic: {
            count: "Total",
            categories: "Categories",
            byCategory: "By category",
            perMonth: "Monthly invoices",
            clients: "Clients",
            sum: "Amount without tax",
            sumTax: "Amount with tax"
        },
        reports: {
            label: "Accounting reports",
            new: "New accounting report",
            scan: "Scan of the report",
            info: "Information about the report",
        },
        extracts: {
            label: "Bank statements",
            new: "New bank statement",
            scan: "Statement scan",
            info: "Statement information",
        },
        contracts: {
            label: "Contracts",
            new: "New contract",
            scan: "Contract scan",
            info: "Information about the contract",
        },
        documents: {
            label: "Documents",
            new: "New document",
            scan: "Document scan",
            info: "Document information",
        },
        property: {
            label: "Real estate",
            new: "New real estate document",
            scan: "Document scan",
            info: "Document information",
        },
        purchases: {
            label: "Expenses",
            new: "New receipt",
            scan: "Receipt scan",
            info: "Receipt information",
        },
        sales: {
            label: "Revenue",
            new: "New invoice",
            scan: "Account",
            number: "Invoice number"
        },
        offers: {
            label: "Price offers",
            new: "New price offer",
            scan: "Scan of the price offer",
            number: "Number of the price offer"
        },
        waybills: {
            label: "Waybills",
            new: "New waybills",
            scan: "Document scan",
            info: "Waybill information",
        },
        garage: {
            label: "Auto repair",
            new: "New document",
            scan: "Document scan",
            info: "Repair information",
        },
        details: "Details",
        serviceList: "List of services",
        newService: "New service",
        totalWithoutTax: "Total without VAT",
        total: "Total",
        fromClient: "From the customer"
    },
    account: "Personal account",
    auth: "Authorization",
    registration: "Registration",
    password: "Password",
    forget: "Forgot password?",
    enter: "Log in",
    create: "Create account",
    stayIn: "Stay in the system",
    logout: "Log out of account",
    other: "Other",
    passport: "Passport",
    residence: "Residence permit",
    signup: {
        cancel: "Cancel registration",
        hello: "Hello! To work with this platform, please leave your data",
        name: "Your name",
        lastname: "Your last name",
        wantTitle: "Do you want to work with us?",
        wantSubtitle: " Please fill out the questionnaire. It will take you only 15 minutes. Your data is needed solely for employment and your convenience at work. They will be inaccessible to outsiders",
        birthdate: "Date of birth",
        bankAccount: "Bank account number",
        whereTitle: "Where do you live?",
        whereSubtitle: "We need your address so that we can register you and send you letters from the company",
        addressFin: "Finnish address",
        addressFromFin: "Since you are from Finland, it is enough to enter your Finnish address",
        addressOwn: "Address in your native country",
        additionalTitle: "Some additional information",
        additionalSubtitle: "We also need this information, because the reason why it is needed will be written here",
        skillsTitle: "Evaluate your skills",
        skillsSubtitle: "So you will receive only those projects that you can handle easily and efficiently",
        mainSpec: "Your main specialty",
        selectSpec: "Choose a specialty from the list",
        almostTitle: "Almost everything...",
        almostSubtitle: "Upload the listed documents for admission to work",
        photo: "Your photo",
        photoSubtitle: "Make sure your face is clearly visible and you are looking into the camera. It is better if the photo is like for a passport",
        residenceSubtitle: "For foreigners it is a mandatory document",
        cardsTitle: "There are only cards left",
        cardsSubtitle: "Select all the cards you have. The presence of a tax card is mandatory! If some cards from the list are missing, you can upload them later when editing your account",
        congratTitle: "Congratulations!",
        congratSubtitle: "Your account has been successfully created. In the account editing mode, you can enter the remaining data or correct the existing ones. You can start working with the platform!",
        wantRentTitle: "Do you want to rent a platform?",
        wantRentSubtitle: "To do this, fill out a questionnaire about your company to make the platform the most convenient for your business. Filling out the questionnaire will take about 5 minutes",
        congratRentSubtitle: "Your application has been accepted. We will contact you within 7 days to discuss the details of renting the platform. You will also have a 14-day trial period",
        contactInfoTitle: "Contact information",
        contactInfoSubtitle: "How can we contact you?",
        detailsSubtitle: "To generate a payment invoice",
    },

    // Для старой версии
    Index: {
        h1Label: "Main",
        hello: "Welcome, ",
        todayLabel: "Today",
        statistics: {
            news: {
                label: "News: ",
                text: "news"
            },
            workers: {
                label: "Workers: ",
                all: "workers",
                new: "New for today",
                text: "At work: ",
            },
            clients: {
                label: "Clients: ",
                all: "clients",
                new: "New for today",
            },
            objects: {
                label: "Objects: ",
                all: "objects",
                text: "At work",
            },
            calendar: {
                label: "Calendar: ",
                all: "events",
                week: "This week",
                today: "Today",
            },
        },
    },
    settings: {
        'language-settings': 'Languages',
        'holidays': 'Holidays',

        'workTypes': 'Types of work',

        selectThemeLabel: "Theme selection",
        selectLangLabel: "Interface language",
        languages: {
            rus: "Russian",
            eng: "English",
            fin: "Finnish",
            est: "Estonian",
            ukr: "Ukrainian",
            swe: "Swedish",
        },
        groups: "User Group Management",
        workerPosition: "Employee Specialties",
        contactPosition: "Contact Positions",
        chequeCategories: "Check Categories",
        reportsCategories: "Accounting Report Categories",
        goals: "Travel goals",
        banks: "Banks",
        terms: "Deadlines",
        tax: "Tax",
        cards: "Cards",
        read: "Reading",
        edit: "Editing",
        absenceReasons: "Reason of absence",
        skills: "Skills",
        companyData: "Сompany data",
        tripTime: "Trip time for reporting",
    },

    invalid_credentials: "Invalid email or password. Check the entered data",
    recoveryPassword: "Password recovery",
    repeatPassword: "Repeat password",
    emailNotification: "Password recovery link sent to email",
    recoveryButton: "Restore password",
    samePasswordRule: "Passwords don't match",
    min8Rule: "Min 8 characters",
    notFound: "Page's not found",
    notFoundSubtitle: "It seems that you clicked on a non-existent link or entered an incorrect address",
    goMain: "Go to the main page",
    editingComment: "Editing comment",
    pause: "Pause",
    minutes: "min",
    hour: "h",
    hours: "Hours",
    sortDescending: "descending",
    sortAscending: "ascending",
    perPage: "Per page",
    details: "Details",
    addDetails: "Add details",
    editDetails: "Edit details",
    selectType: "Select type",
    "e-account": "E-billing",
    detailAddress: "E-billing address",
    operator: "Electronic billing operator",
    operator_id: "Operator ID",
    invoice_address: "E-mail invoice address",
    client_name: "Client's name",
    bank: "Bank",
    bic: "BIC",
    iban: "IBAN",
    addLink: "Add link",
    editLink: "Edit link",
    addCategory: "Add category",
    link: "Link",
    newComments: "New comments",
    notFoundAnswer: "Didn't find the answer to your question?",
    text: "Text",
    reason: "Reason of absence",
    showQua: "Display in the questionnaire",

    technical: "Technical work is underway on the site. Please come back later",
    technicalTime: "The work will last from 13 to 23",
    error500: "Internal server error",
    selectShownHeaders: "Select shown fields",
    preview: "Preview",
    payment: "Payment",
    sendToEmail: "Send to email",
    send: "Send",
    simpleReg: "Short form",
    history: "History of changes",
    author: "Author",
    beforeChanges: "Before changes",
    afterChanges: "After changes",
    answer: "Answer for comment",
    markRead: "Mark as read",
    read_timings: "Give access to reporting",
    productCode: "Product code",
    eanCode: "EAN-code",
    shops: 'Shops',
    shop: 'Shop',
    addShop: "Add shop",
    sellers: "Sellers",
    seller: "Seller",
    addSeller: "Add seller",
    addProduct: "Add item",
    connection: "Contacts",
    rentPlatform: "Rent platform",
    contactPerson: "Contact person",
    contactPersonSubtitle: "This person will be the first user and admin of the system",
    subdomain: "Subdomain",
    lastLogin: "Last login",
    products: "Products",
    addBusinessCard: "Add business card",
    frontPhoto: "Front side",
    backPhoto: "Back side",
    todoComment: "Comment will be added to the object",
    addTask: "Add task",
    workerLimit: "Workers maximum",
    functions: "Functions",
    paid_until: "Paid until",
    domain: "Domain",
    onTrial: "On trial",
    choose: "Choose",
    chooseTariff: "Choose tariff",
    chosen: "Chosen",
    rentInfo: "Rent information",
    createdDateTenant: "Registration date",
    tariffPlan: "Tariff plan",
    changeTariff: "Change tariff plan",
    pay_platform: "Pay for using platform",
    archiveable: "Archive in 7 days",
    success: "Payment was successful",
    error: "Payment error",
    contactAdmin: "Contact the administrator",
    stripe: "Stripe product code",
    pay: "Pay",
    uploadedFiles: "Uploaded files",
    safePassword: "Password for safe",
    updatePassword: "Update password",
    invalidPassword: "Invalid password",
    safeAlert: "We do not recommend storing passwords and other important information here.\n The site administration is not responsible for the safety of data in the safe",
    dateTimings: "Reports dates",
    withArch: "Consider archived",
    copy: "Copy",
    timingChanges: "Changes to hourly reports",
    checkIn: "Check in",
    checkOut: "Check out",
    workerOnObject: "On object since ",
    showGeo: "Show geolocation",
    endWithoutReport: "Finish without report",
    translate: "Translate",
    showOriginal: "Show original",
    repeat: "Recurring",
    once: "Once",
    weekly: "Weekly",
    monthly: "Monthly",
    yearly: "Yearly",
    until: "Until",
    showHistory: "Show history",
    contactsVisible: "Make contacts visible",
    geoError: "Geolocation error",
    workerLimitError: "The allowed number of employees in the system has been exceeded",
    changeDate: "Replace to another date",
    downloadAllFiles: "Download all files",
    addSignature: "Scan signature",
    signature: "Signature",
    permissionError: "Permission denied",
    methodNotAllowedError: "Method not allowed",
    unexpectedError: "Unexpected error",
    userExists: "User already exists",
    tripTime: "Trip time",

    "dgantt": {
        "title": "Chart",
        "tasks": "Tasks",
        'workType': 'type of work',

    },
    "months": {
        "Jan": "January",
        "Feb": "February",
        "Mar": "March",
        "Apr": "April",
        "May": "May",
        "Jun": "June",
        "Jul": "July",
        "Aug": "August",
        "Sep": "September",
        "Oct": "October",
        "Nov": "November",
        "Dec": "December"
    },

    "days": {
        "Mon": "Mon",
        "Tue": "Tue",
        "Wed": "Wed",
        "Thu": "Thu",
        "Fri": "Fri",
        "Sat": "Sat",
        "Sun": "Sun"
    },
    "days_genitive": 'days',
    "filter": "Filter",
    expiredDocuments: "Expired documents",
    upcomingAbsence: "Upcoming vacations",
    'selectedSection': 'Selected section',

    'holiday-work': 'weekend work',
    organizationCar: "Organization car",
    personal: "Personal",
    fromOrganization: "Organizations",
    maybe: "Maybe you meant",
    partners: "Partners",
    fromNotes: "From notes",
    invitations: "Invitations",
    from: "From",
    accept: "Accept",
    reject: "Reject",
    find: "Find",
    contractor: "Contractor",
    orgEmail: "Organization Email",
    profileExist: "Do you have a registered profile?",
    vat: "VAT",
    discountCards: "Discount cards",
    dueTo: "Due to",
    workingDays: "Working days",
    chosenHolidays: "Chosen holidays",
    usedLanguages: "Used languages",
    cv: "CV",
    loadFromProfile: "Load from profile",
    addressResidence: "Residential address",
    region: "Region",
    experience: "Experience",
    startDate: "Start date",
    addExperience: "Add experience",
    education: "Education",
    educationalInstitution: "Educational institution",
    startYear: "Start year",
    endYear: "End year",
    educationSphere: "Education sphere",
    education_level: "Education level",
    educationLevel: {
        "general": "Basic",
        "middle": "Secondary",
        "technical": "Vocational",
        "high": "Higher",
        "diploma": "Diploma",
        "bachelor": "Bachelor",
        "master": "Master",
        "doctor": "Doctor"
    },
    educationHighLevel: "Education received",
    licenses: "Licenses and certificates",
    language: "Language",
    languageLevel: "Knowledge level",
    languageLevels: {
        "A1": "A1 - starter",
        "A2": "A2 - elementary",
        "B1": "B1 - intermediate",
        "B2": "B2 - upper-intermediate",
        "C1": "C1 - advanced",
        "C2": "C2 - proficient or native language",
    },
    numberOrUrl: "License number or URL",
    issued: "Issued (by whom?)",
    year: "Year",
    portfolio: "Portfolio",
    current: "Current",
    "saveAndClose": "Save and close",
    "profile": {
        "works_at": "Works at"
    },
    "offerResume": "Offer resume",
    upload: "Upload",
    addressVacancy: "Vacancy address",
    "cvs": {
        "personalData": "Personal Data",
        "about": "About",
        "aboutMe": "About Me",
        "invite": "Invite",
        "location": "Location",
        "residence_city": "City of Residence",
        "residence_country": "Country of Residence",
        "residence_region": "Region of Residence",
        "status": "Status",
        "statuses": {
            "none": "it doesn't matter",
            "busy": "Busy",
            "free": "Free",
            "busy_additional": "Available for additional work"
        },
        "skills": "Skills",
        "contacts": "Contacts",
        "radius": "Search radius",
        "residence_address": "Address of residence",
        "issued": "Issued"
    },
    "hh": {
        "CV": "CV",
        "active": "Active vacancy",
        "additionalInfo": "Additional Information",
        "address": "Address",
        "approve": "Approve",
        "city": "City",
        "company": "Company",
        "contact_person": "Contact Person",
        "country": "Country",
        "cover_letter": "Cover Letter",
        "decline": "Decline",
        "description": "Description",
        "details": "Details",
        "firstname": "First Name",
        "has_approved_organization_by_organization": "You have agreed to hire a candidate",
        "has_approved_organization_by_worker": "You have been hired",
        "has_approved_worker_by_company": "Candidate agrees to go to work",
        "has_approved_worker_by_worker": "You agree to go to work",
        "has_declined_organization_by_organization": "You rejected the resume",
        "has_declined_organization_by_worker": "Your candidacy was rejected by the company",
        "has_declined_worker_by_company": "The candidate rejected your vacancy",
        "has_declined_worker_by_worker": "You rejected the vacancy",
        "has_not_approved_organization_by_worker": "The company is still reviewing your resume",
        "has_not_approved_worker_by_company": "The candidate has not yet made a decision",
        "highlights": "Highlights",
        "lastname": "Last Name",
        "location": "Location",
        "mainInfo": "Main Information",
        "noCv": "No CV",
        "noVacancy": "No Vacancy",
        "offer": "Offer",
        "position": "Position",
        "region": "Region",
        "remote": "Remote work",
        "respond": "Respond",
        "salary": "Salary",
        "skills": "Required skills",
        "type": "Type",
        "vacancy": "Vacancy",
        "worker": "Worker",
        "fulltime": "Full-time",
        "parttime": "Part-time",
        "temporary": "Temporary",
        "contract": "Contract",
        "seasonal": "Seasonal",
        "volunteer": "Volunteer",
        "responsibilities": "Responsibilities",
        "documents": "Necessary documents",
        "useful": "It will be useful",
        "salaryType": "Salary type",
        "currency": "Currency",
        "netto": "on hand",
        "brutto": "before tax",
        "conditions": "Conditions",
        "need_experience": "Experience is required",
        "experience": "Experience",
        "not_remote": "No",
        "vacancy_address": "Vacancy address",
        "responded": "You have already responded",
        "responded_work": "You are already working here",
        "declined": "Application rejected",
        "approved_for_worker": "You have been hired",
        "approved_for_organization": "The employee has been hired. It is necessary to assign rights to him",
        "search": "Search by position and skills"
    },
    "min": "Minimum",
    "max": "Maximum",
    "open": "Open",
    "editedLanguages": "Editable languages",
    "chat": "Chat",
    "dismiss": "Dismiss",
    "dismissed": "Dismissed",
    "hire": "Hire",
    "maintenanceReports": "Maintenance/repair",
    "worksAndMaterials": "Works and materials",
    "receipt": "Receipt",
    "maintenanceType": "Maintenance type",
    "material": "Material",
    "work": "Work",
    "otherType": "Other",
    "code": "Code",
    "nextServiceDate": "Next service date",
    "codeMaterial": "Code of material",
    "codeWork": "Code of work",
    "km": "км",
    "editNews": "Edit news",
    "undo": "Undo",
    "redo": "Redo",
    "Bold": "Bold",
    "Italic": "Italic",
    "Link": "Link",
    "AlignLeft": "Align Left",
    "AlignCenter": "Align Center",
    "AlignRight": "Align Right",
    "OrderedList": "Ordered List",
    "UnorderedList": "Unordered List",
    "InsertImage": "Insert Image",
    "ClearFormatting": "Clear Formatting",
    "Heading1": "Heading 1",
    "Heading2": "Heading 2",
    "Heading3": "Heading 3",
    "InsertTable": "Insert Table",
    "TableBorders": "Table Borders",
    "TextColor": "Text color",
    "EnterHyperlink": "Enter hyperlink",
    "rows": "Rows",
    "columns": "Columns",
    "MinValueError": "Please specify the number of rows and columns (minimum 1)",
    "brutto": "Brutto",
};
//# sourceMappingURL=en.js.map